import { State } from 'index'
import { db, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'
import { StoreType } from 'types/store'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { saveStoreInformationAction } from 'reducks/store/actions'

const saveStoreInformation = (
  store: StoreType,
  storeId: string,
  isCreatePage: boolean,
  isEventPage: boolean,
  isConfirmed: boolean,
  isEditedByOwner: boolean
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const now = FirebaseTimestamp.now()
    const batch = db.batch()
    const shop = getState().shop

    switch (true) {
      // 新規作成の場合
      case isCreatePage && !isEventPage:
        if (!store.shop_ref) return
        store.created_at = now
        store.updated_at = now
        dispatch(showLoadingAction())
        batch.set(
          store.shop_ref,
          {
            contact: shop.contact,
            name: shop.name,
            responsible_person: shop.responsible_person,
            shop_id: store.shop_ref.id,
            stripe_account_id: shop.stripe_account_id,
            invoice_business_name: shop.invoice_business_name,
            invoice_number: shop.invoice_number,
          },
          { merge: true }
        )
        store.is_before_publishing_stock = true
        batch.set(db.collection('stores').doc(storeId), store, { merge: true })

        return batch
          .commit()
          .then(() => {
            dispatch(hideLoadingAction())
            dispatch(saveStoreInformationAction(store))
            if (isCreatePage) {
              dispatch(push(`/admin/shops/${storeId}/invite_owner`))
            } else if (!isEditedByOwner) {
              if (isEventPage) {
                dispatch(push(`/admin/events/${storeId}/information/complete`))
              } else {
                dispatch(push(`/admin/shops/${storeId}/information/complete`))
              }
            }
          })
          .catch((error) => {
            console.error(error)
            dispatch(hideLoadingAction())
          })

      // 催事の登録・編集画面から確認画面へ
      case isEventPage && !isConfirmed:
        dispatch(saveStoreInformationAction(store))
        dispatch(push(`/admin/events/${storeId}/information/confirm`))
        break

      // 催事の確認画面から完了画面へ
      case isEventPage && isConfirmed:
        store.updated_at = now
        dispatch(showLoadingAction())
        delete store.shop_ref
        batch.set(db.collection('stores').doc(storeId), store, { merge: true })

        return batch
          .commit()
          .then(() => {
            dispatch(hideLoadingAction())
            dispatch(saveStoreInformationAction(store))
            if (isCreatePage) {
              dispatch(push(`/admin/events/${storeId}/information/complete`))
            } else {
              dispatch(push(`/admin/shops/${storeId}/information/complete`))
            }
          })
          .catch((error) => {
            console.error(error)
            dispatch(hideLoadingAction())
          })
    }
  }
}

export default saveStoreInformation
